/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { User } from './User';
import {
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
    UserToJSONTyped,
} from './User';
import type { LeadAdmissionFlagsInnerAdmissionFlagAliasesInner } from './LeadAdmissionFlagsInnerAdmissionFlagAliasesInner';
import {
    LeadAdmissionFlagsInnerAdmissionFlagAliasesInnerFromJSON,
    LeadAdmissionFlagsInnerAdmissionFlagAliasesInnerFromJSONTyped,
    LeadAdmissionFlagsInnerAdmissionFlagAliasesInnerToJSON,
    LeadAdmissionFlagsInnerAdmissionFlagAliasesInnerToJSONTyped,
} from './LeadAdmissionFlagsInnerAdmissionFlagAliasesInner';

/**
 * 
 * @export
 * @interface LeadAdmissionFlagsInnerAdmissionFlag
 */
export interface LeadAdmissionFlagsInnerAdmissionFlag {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    first_name: string;
    /**
     * 
     */
    last_name: string;
    /**
     * 
     */
    dob?: string;
    /**
     * 
     */
    category: LeadAdmissionFlagsInnerAdmissionFlagCategoryEnum;
    /**
     * 
     */
    comment?: string;
    /**
     * 
     */
    created_at?: string;
    /**
     * 
     */
    created_by_user?: User;
    /**
     * 
     */
    gender?: string | null;
    /**
     * 
     */
    aliases?: Array<LeadAdmissionFlagsInnerAdmissionFlagAliasesInner>;
}


/**
 * @export
 */
export const LeadAdmissionFlagsInnerAdmissionFlagCategoryEnum = {
    Behavioral: 'Behavioral',
    Financial: 'Financial',
    Clinical: 'Clinical',
    Other: 'Other',
} as const;
export type LeadAdmissionFlagsInnerAdmissionFlagCategoryEnum = typeof LeadAdmissionFlagsInnerAdmissionFlagCategoryEnum[keyof typeof LeadAdmissionFlagsInnerAdmissionFlagCategoryEnum];


/**
 * Check if a given object implements the LeadAdmissionFlagsInnerAdmissionFlag interface.
 */
export function instanceOfLeadAdmissionFlagsInnerAdmissionFlag(value: object): value is LeadAdmissionFlagsInnerAdmissionFlag {
    if (!('first_name' in value) || value['first_name'] === undefined) return false;
    if (!('last_name' in value) || value['last_name'] === undefined) return false;
    if (!('category' in value) || value['category'] === undefined) return false;
    return true;
}

export function LeadAdmissionFlagsInnerAdmissionFlagFromJSON(json: any): LeadAdmissionFlagsInnerAdmissionFlag {
    return LeadAdmissionFlagsInnerAdmissionFlagFromJSONTyped(json, false);
}

export function LeadAdmissionFlagsInnerAdmissionFlagFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeadAdmissionFlagsInnerAdmissionFlag {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'first_name': json['first_name'],
        'last_name': json['last_name'],
        'dob': json['dob'] == null ? undefined : json['dob'],
        'category': json['category'],
        'comment': json['comment'] == null ? undefined : json['comment'],
        'created_at': json['created_at'] == null ? undefined : json['created_at'],
        'created_by_user': json['created_by_user'] == null ? undefined : UserFromJSON(json['created_by_user']),
        'gender': json['gender'] === undefined ? undefined : json['gender'] === null ? null : json['gender'],
        'aliases': json['aliases'] == null ? undefined : ((json['aliases'] as Array<any>).map(LeadAdmissionFlagsInnerAdmissionFlagAliasesInnerFromJSON)),
    };
}

export function LeadAdmissionFlagsInnerAdmissionFlagToJSON(json: any): LeadAdmissionFlagsInnerAdmissionFlag {
    return LeadAdmissionFlagsInnerAdmissionFlagToJSONTyped(json, false);
}

export function LeadAdmissionFlagsInnerAdmissionFlagToJSONTyped(value?: LeadAdmissionFlagsInnerAdmissionFlag | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'dob': value['dob'],
        'category': value['category'],
        'comment': value['comment'],
        'created_at': value['created_at'],
        'created_by_user': UserToJSON(value['created_by_user']),
        'gender': value['gender'],
        'aliases': value['aliases'] == null ? undefined : ((value['aliases'] as Array<any>).map(LeadAdmissionFlagsInnerAdmissionFlagAliasesInnerToJSON)),
    };
}

